module.exports = __webpack_public_path__ + "static/media/img_privado.7c103c16.jpg";